export default __webpack_public_path__ + "static/media/staff5.067a0842.jpeg";